var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoginLogo = function SvgLoginLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loginLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 32.721C41 21.395 29.505 8.82 23.73 1.553A4.1 4.1 0 0 0 22.296.41a4.145 4.145 0 0 0-3.59 0c-.559.27-1.05.66-1.434 1.143C11.494 8.82.003 21.48.003 32.721.003 43.921 9.18 53 20.503 53S41 43.921 41 32.721Z",
    fill: "#FF6969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.471 33.464s-1.36 1.48-5.622 1.176c-4.263-.304-5.279-3.02-5.905-4.248-.658-1.288-3.135-3.373-6.288-2.213-1.834.673-3.294 1.854-3.708 4.295-.165.968-.057 2.241.36 3.572.71 2.28 3.504 7.549 10.656 8.221 6.855.647 10.75-5.595 11.277-6.777.527-1.182 1.286-3.222.387-3.927-.62-.49-1.157-.1-1.157-.1Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loginLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h41v53H0z"
  })))));
};
export default SvgLoginLogo;